import api from './api'

export default {
  getPermission: () => api.get('admin/api/v1/profile/allowed_admin_permission'),
  getProfile: () => api.get('admin/api/v1/profile/get'),
  updateProfile: payload => api.patch('admin/api/v1/profile/update', payload),
  updatePassword: payload => api.patch('admin/api/v1/profile/update_password', payload),
}
